module.exports = __webpack_public_path__ + "img/picture_news_02.71c6f30d.png";